
export default function Footer() {
  return (
    <footer className="bg-[#F5F5F5] border-t border-gray-200">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-12">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 mb-10">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/2e4355bb8afb16b3015e9a84e75a64ec/50fde72ea7ea1006ed7bc96a5b4ff55a.png"
              alt="Precious Leader Trade Far East Limited"
              className="h-20 w-auto"
            />
          </div>

          <div className="flex flex-wrap gap-8">
            <a 
              href="/privacy-policy" 
              className="text-[14px] text-[#666666] hover:text-[#B11226] transition-colors whitespace-nowrap"
            >
              Privacy Policy
            </a>
            <a 
              href="/terms-of-use" 
              className="text-[14px] text-[#666666] hover:text-[#B11226] transition-colors whitespace-nowrap"
            >
              Terms of Use
            </a>
            <a 
              href="/cookie-policy" 
              className="text-[14px] text-[#666666] hover:text-[#B11226] transition-colors whitespace-nowrap"
            >
              Cookie Policy
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
          <p className="text-[13px] text-[#666666] leading-relaxed">
            <strong className="text-[#111111]">Disclaimer:</strong> Information on this website is for general purposes and does not constitute financial, legal or investment advice. Precious Leader Trade Far East Limited does not provide regulated financial services. All advisory services are provided on a non-regulated, strategic consulting basis.
          </p>
        </div>

        {/* Contact Information */}
        <div className="mb-6">
          <p className="text-[14px] text-[#666666] leading-relaxed">
            Registered in Hong Kong<br />
            Business Registration No. 74702250
          </p>
        </div>

        {/* Bottom Section */}
        <div className="text-center pt-6 border-t border-gray-200">
          <p className="text-[13px] text-[#666666]">
            © {new Date().getFullYear()} Precious Leader Trade Far East Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}